<template>
    <div class="d-flex justify-content-center align-items-center h-100 w-100">
        <div class="d-flex justify-content-center align-items-start gap-1 text-muted" style="line-height: 1.2">
            <icon name="cil-check-circle" style="margin-top: 2px" />
            <div>
                {{ text }}
            </div>
        </div>
    </div>
</template>
<script setup>
const props = defineProps({
    text: {
        type: String,
        required: true,
    },
});
</script>
